import { render, staticRenderFns } from "./TableCom.vue?vue&type=template&id=ca0ba08e&scoped=true"
import script from "./TableCom.vue?vue&type=script&lang=js"
export * from "./TableCom.vue?vue&type=script&lang=js"
import style0 from "./TableCom.vue?vue&type=style&index=0&id=ca0ba08e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ba08e",
  null
  
)

export default component.exports